"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UUID = void 0;
var UUID = exports.UUID = 'uuid';